/*
 * cart-availability.js
 * ------------------------------------------------------------------
 * Keeps the Checkout buttons (#checkout on the cart page and
 * #CartDrawer-Checkout in the drawer) blocked while the cart contains an
 * item that can't be sold/shipped to the current region.
 *
 * Liquid already renders the buttons disabled on first load (see
 * main-cart-footer.liquid / cart-drawer.liquid via cart_has_unavailable).
 * This script re-evaluates after AJAX cart updates, because the main-cart
 * checkout button sits OUTSIDE the .js-contents area that the cart re-renders
 * on quantity change / remove — so without this it would stay stale.
 *
 * Source of truth in the DOM: each sold-out line renders a
 * [data-cart-item-unavailable] marker inside the (re-rendered) item list.
 * ------------------------------------------------------------------
 */
(function () {
  if (window.__cartAvailabilityInit) return;
  window.__cartAvailabilityInit = true;
  var snapshot = null;

  function sync() {
    var current = window.BallistaCartCompatibility?.getAvailability?.() || snapshot;
    var hasUnavailable = current ? current.unavailable : document.querySelector('[data-cart-item-unavailable]') !== null;
    var itemCount = current ? current.itemCount : document.querySelectorAll('.cart-item').length;

    document.querySelectorAll('#checkout, #CartDrawer-Checkout, #cart-notification-form [name="checkout"]').forEach(function (btn) {
      // Keep empty-cart behaviour intact: a button with no items stays disabled.
      if (itemCount === 0 || hasUnavailable) {
        btn.dataset.cartAvailabilityDisabled = 'true';
        btn.disabled = true;
      } else if (btn.dataset.cartAvailabilityDisabled === 'true') {
        delete btn.dataset.cartAvailabilityDisabled;
        if (!window.disable_checkout_MOQ && !window.WSAIO?.disable_checkout) btn.disabled = false;
      }
    });

    document.querySelectorAll('[data-cart-soldout-warning]').forEach(function (note) {
      note.classList.toggle('hidden', !hasUnavailable);
    });
  }

  function start() {
    document.addEventListener('cart:availability', function (event) {
      snapshot = event.detail;
      sync();
    });
    document.addEventListener('cart:rendered', sync);
    sync();

    // Re-sync on every cart mutation published by the theme (add / qty / remove).
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, sync);
    }

    // Belt-and-braces: also watch the cart containers for innerHTML swaps,
    // so we don't depend on the publish() call firing.
    var targets = [
      document.getElementById('main-cart-items'),
      document.getElementById('main-cart-footer'),
      document.querySelector('cart-drawer'),
    ].filter(Boolean);

    if (targets.length && 'MutationObserver' in window) {
      var observer = new MutationObserver(function () { sync(); });
      targets.forEach(function (el) {
        observer.observe(el, { childList: true, subtree: true });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
